export const AUTH = "auth";
export const PROFILE = "profile";
